import React from "react";
import { motion } from "framer-motion";
import "../App.css";

function Summary() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">Professional Summary</h2>
      <div className="card-custom">
        <p className="mb-0 lead text-dim" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
          I am a highly motivated <strong className="text-accent">Software Engineer</strong> and <strong className="text-accent">Full Stack Developer</strong> with 
          a strong foundation in Computer Science and Cloud Computing. With hands-on expertise in the 
          <strong> MERN Stack (MongoDB, Express, React, Node.js)</strong> and <strong>Enterprise Java (Spring Boot)</strong>, 
          I specialize in building scalable, secure, and high-performance web applications. My technical journey 
          includes developing complex backend architectures, designing intuitive user interfaces, and 
          integrating cutting-edge **AI technologies (Google Gemini)** into real-world projects. 
          As an **AWS Academy Graduate**, I leverage cloud-native solutions to optimize application 
          deployment and infrastructure. I am passionate about continuous learning, architectural excellence, 
          and delivering impactful digital solutions that solve complex business challenges.
        </p>
      </div>
    </div>
  );
}

export default Summary;
